import React from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { ErrorBoundary } from "./components/ErrorBoundary/ErrorBoundary";
import { theme } from "./theme";
import { BrowserRouter as Router } from "react-router-dom";
import logo from "./logo.svg";
import './assets/style/global.css';
import AppRoutes from "./routes/AppRoutes";
import { Provider } from "react-redux";
import { store } from './store/store';

function App() {
  return (
    <ThemeProvider theme={theme}>
        <Provider store={store}>
            <CssBaseline />
            <Router>
              <AppRoutes />
            </Router>
        </Provider>
    </ThemeProvider>
  );
}

export default App;
